import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import type { IconButtonProps } from '@mui/material';

export type BlockSettingsToolButtonProps = {
  title: string;
} & IconButtonProps;

export default function BlockSettingsToolButton({ title, children, ...props }: BlockSettingsToolButtonProps) {
  return (
    <Tooltip
      title={title}
      placement="top"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -4],
              },
            },
          ],
        },
      }}
    >
      <IconButton size="small" {...props} sx={{ color: 'primary.contrastText' }}>
        {children}
      </IconButton>
    </Tooltip>
  );
}
